import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'jarvis-disabled-page',
  templateUrl: './disabled-page.component.html',
  styleUrls: ['./disabled-page.component.scss'],
})
export class DisabledPageComponent {
  pageKey: string = this.route.snapshot.paramMap.get('pageKey');

  constructor(private route: ActivatedRoute) {}
}
